module.exports = __webpack_public_path__ + "img/240.74c3483e.jpg";